import { render, staticRenderFns } from "./OriginalAddress.vue?vue&type=template&id=58397cc4&scoped=true&"
import script from "./OriginalAddress.vue?vue&type=script&lang=js&"
export * from "./OriginalAddress.vue?vue&type=script&lang=js&"
import style0 from "./OriginalAddress.vue?vue&type=style&index=0&id=58397cc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58397cc4",
  null
  
)

export default component.exports